import { useState } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Menu, IconButton } from '@mui/material';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { styled, alpha } from '@mui/material/styles';
import OrderNotesList from '../tickets/ticket/OrderNotesList';
import Iconify from '../../../reusable-components/iconify/Iconify';

OrderNotesViewModal.propTypes = {
  order: PropTypes.object,
  inOrder: PropTypes.bool,
};

export default function OrderNotesViewModal({ order, inOrder }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClickOpen = (event) => {
    event.openTicket = true;
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  return <>
    <Tooltip arrow title={inOrder || order?.messageCount > 0 ? 'Open order notes' : 'Add note'}>
      <IconButton disableRipple onClick={handleClickOpen} sx={{ opacity: 0.8, p: 0 }}>
        {inOrder ? <>
          <Iconify onClick={handleClickOpen}
          icon={"grommet-icons:notes"}
          width={16}
          height={16}
          color="secondary"
        />
        </> : order?.messageCount > 0 ? <FileOpenIcon width={28} height={28} color="info" /> : <NoteAddIcon width={28} height={28} color="secondary" />}
      </IconButton>
    </Tooltip>

    {order && <StyledMenu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose}>
      <OrderNotesList id={order.id} />
    </StyledMenu>}
  </>;
}

const StyledMenu = styled((props) => (<Menu elevation={0} {...props} />))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    maxHeight: 300,
    color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      },
    },
  },
}));
